import { connectInstructions } from "../../util/redux";
import StopOrGoInstructionsComponent from "../../components/stop-or-go/instructions";

const StopOrGoInstructions = connectInstructions(StopOrGoInstructionsComponent);

export default StopOrGoInstructions;
